(function () {
  'use strict';

  var form = document.getElementById('ProductForm');
  if (!form) return;

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  var variantIdInput = document.getElementById('ProductVariantId');
  var priceEl = document.getElementById('ProductPrice');
  var compareEl = document.getElementById('ProductComparePrice');
  var discountEl = document.getElementById('ProductDiscount');
  var addBtn = document.getElementById('ProductAddButton');
  var addLabel = document.getElementById('ProductAddLabel');
  var outOfStockEl = document.getElementById('ProductOutOfStock');

  document.querySelectorAll('.pf-variant-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (pill.disabled) return;

      document.querySelectorAll('.pf-variant-pill').forEach(function (p) {
        p.classList.remove('is-active');
        p.setAttribute('aria-checked', 'false');
      });
      pill.classList.add('is-active');
      pill.setAttribute('aria-checked', 'true');

      var id = pill.getAttribute('data-variant-id');
      var price = parseInt(pill.getAttribute('data-variant-price'), 10);
      var comparePrice = parseInt(pill.getAttribute('data-variant-compare-price'), 10);
      var available = pill.getAttribute('data-variant-available') === 'true';

      if (variantIdInput) variantIdInput.value = id;
      if (priceEl) priceEl.textContent = formatMoney(price);

      if (comparePrice > price) {
        if (compareEl) { compareEl.textContent = formatMoney(comparePrice); compareEl.hidden = false; }
        if (discountEl) {
          var pct = Math.round(((comparePrice - price) / comparePrice) * 100);
          discountEl.textContent = '−' + pct + '%';
          discountEl.hidden = false;
        }
      } else {
        if (compareEl) compareEl.hidden = true;
        if (discountEl) discountEl.hidden = true;
      }

      if (addBtn) addBtn.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Ajouter au panier' : 'Indisponible';
      if (outOfStockEl) outOfStockEl.hidden = available;
    });
  });

  var qtyValue = document.getElementById('QtyValue');
  var qtyInput = document.getElementById('QtyInput');
  var qtyMinus = document.getElementById('QtyMinus');
  var qtyPlus = document.getElementById('QtyPlus');

  function setQty(n) {
    n = Math.max(1, n);
    if (qtyValue) qtyValue.textContent = n;
    if (qtyInput) qtyInput.value = n;
  }

  if (qtyMinus) qtyMinus.addEventListener('click', function () {
    setQty((parseInt(qtyInput.value, 10) || 1) - 1);
  });
  if (qtyPlus) qtyPlus.addEventListener('click', function () {
    setQty((parseInt(qtyInput.value, 10) || 1) + 1);
  });

  document.querySelectorAll('.pf-tabs__head [role="tab"]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.getAttribute('data-tab');
      document.querySelectorAll('.pf-tabs__head [role="tab"]').forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      document.querySelectorAll('.pf-tabs__panel').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-tab-panel') === target);
      });
    });
  });
})();
